import bankSecurity from '../../banksPNG/bankSecurity.png';

interface IconsProps {
	width?: string;
	height?: string;
	alt?: string;
}
export const BancoSecurityIcon = ({
	width = '17px',
	height = '17px',
	alt = 'Banco Security',
}: IconsProps) => <img src={bankSecurity} width={width} height={height} alt={alt} />;
